import http, { handleHttpError, handleHttpResponse } from 'services/http'
import { HTTPResponse } from 'services/http/http.types'
import { IProjectStage } from './projectTypes.types'



const getAll = async (): Promise<HTTPResponse<IProjectStage[]>> => {
  return http.get('/nsi/v1/project-stages').then(handleHttpResponse).catch(handleHttpError)
}

const getOne = async (id: IProjectStage['id']): Promise<HTTPResponse<IProjectStage>> => {
  return http
    .get('/nsi/v1/project-stages/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

export interface ICreateProjectStageDto {
  name: string
  description?: string
  checkpoints: Array<{projectCheckpointId: IProjectStage['id'], orderingIndex: number}>
}

const create = async (dto: ICreateProjectStageDto): Promise<HTTPResponse<IProjectStage>> => {
  return http.post('/nsi/v1/project-stages', dto).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (dto: Partial<ICreateProjectStageDto>, id: IProjectStage['id']): Promise<HTTPResponse<IProjectStage>> => {
  return http
    .patch('/nsi/v1/project-stages/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const projectStagesApi = {
  update,
  create,
  getOne,
  getAll,
}

export default projectStagesApi
